import dashedId from '../../../utils/dashed-id';
import {
  BLOG_CONTENT,
  TABLE_OF_CONTENTS_TITLE_TAG,
  TABLE_OF_CONTENTS_SUBTITLE_TAG
} from '../../../classnames/blog';

export default class BlogTitlesParser {
  getNodeWithIdItem = (node) => ({
    node,
    id: dashedId(node.innerText)
  });

  getNodesWithIds = () => {
    const headingNodes = document
      .querySelector(`.${BLOG_CONTENT}`)
      .querySelectorAll(`${TABLE_OF_CONTENTS_TITLE_TAG}, ${TABLE_OF_CONTENTS_SUBTITLE_TAG}`);

    return [...headingNodes].map(this.getNodeWithIdItem);
  };
}
